import React from 'react';
import TextList from './TextList';
import Heading from '../Headers/Heading';
import { Link } from 'react-router-dom';

const list = [
    {
        title: 'Virtual Reality',
        link: '/Services',
    },
    {
        title: 'Augmented Reality',
        link: '/Services',
    },
    {
        title: 'App & Software',
        link: '/Services',
    },
    {
        title: 'Installations',
        link: '/Services',
    },
        {
        title: 'Simulation',
        link: '/Services',
    },
];

function TextAboutSection() {
    return (
        <div className="text-about-section">
            <div className="text-about-section-wrapper">
                <div className="container">
                    <Heading 
                            heading={<h1>A studio focused on experiences that matter.</h1>}
                            headingClass="heading-very-large dark-1"
                            paragraphClass="dark-2"
                            headingColumn="col-lg-9"
                    />
                    <div className="content-wrapper">
                        <div className="row">
                            {/* list - start */}
                            <div className="col-lg-5 col-md-6">
                                <TextList heading={'SKILLS'} list={list} />
                            </div>
                            {/* list - end */}

                            {/* text - start */}
                            <div className="col-lg-6 col-md-6 content-second-column">
                                <h4 className="content-heading heading heading-small light-2">HISTORY</h4>
                                <div className="paragraph dark-1">
                                    <p>
                                        Studio NORCAT aims to strengthen NORCAT’s mission and programs by creating applied, experience-driven solutions that support learning, training, and workforce development. By combining software, immersive technologies, and experiential design, the Studio helps transform learning into something active, practical, and grounded in real-world needs.
                                    </p>
                                    <p
                                        style={{
                                            height: 'auto',
                                        }}
                                    >
                                        &nbsp;
                                    </p>
                                    <p>
Over the past decade, alongside advances in virtual and augmented reality, Studio NORCAT has grown from exploration into application—working with educators, industry, and innovators to use immersive technology in ways that make learning safer, more effective, and easier to apply on the job.                                 </p>
                                </div>
                                <Link className="button" to="/About">
                                    Learn More
                                </Link>
                            </div>
                            {/* text - end */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TextAboutSection;
